export default "__VITE_ASSET__abe1ce9d__"